import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useFeatureFlags } from 'ha/modules/FeatureFlags';

const useUnitTypeId = () => {
  const { id = '', listingId = '' } = useParams();
  const urlId = listingId || id || '';

  const { tenantMULFlow } = useFeatureFlags();

  // When the id in the URL is prefixed with "ut" then it refers to
  // the unit type id and not unit id
  const isUnitTypeId = useMemo(
    () => tenantMULFlow === 'on' && urlId.includes('ut'),
    [urlId, tenantMULFlow],
  );

  return {
    isUnitTypeId,
  };
};

export { useUnitTypeId };
